export default __webpack_public_path__ + "80560be06b95fe0be83eb989ee1f15e4.webp";